// https://github.com/jquense/yup
// Dead simple Object schema validation

import * as yup from "yup";

// Matches Id::MediaOutlet::DESCRIPTION_MAX_LENGTH — the server rejects anything longer, so the form
// says so before the round trip.
const descriptionMaxLength = 500;

const descriptionSchemaShape = {
  description: yup
    .string()
    .max(descriptionMaxLength, `Description must be fewer than ${descriptionMaxLength} characters.`),
};

const mediaOutletOverviewYupSchema = yup.object().shape(descriptionSchemaShape);

const mediaOutletHeaderYupSchema = yup.object().shape({
  name: yup.string().required("Name is required."),
  // Matches Id::MediaOutlet::HEADLINE_CUSTOM_MAX_LENGTH.
  headline_custom: yup.string().max(200, "Headline must be 200 characters or fewer."),
  // Outlets are keyed on a bare hostname (wsj.com), not a full URL — the enrichment and request
  // pipelines match on it, so a pasted https:// prefix or trailing path has to be rejected here.
  domain: yup
    .string()
    .transform((value) => (typeof value === "string" ? value.trim() : value))
    .matches(/^([a-z0-9-]+\.)+[a-z]{2,}$/i, {
      message: "Domain must be a bare hostname, e.g. example.com",
      excludeEmptyString: true,
    }),
});

export default mediaOutletHeaderYupSchema;
export { descriptionMaxLength, mediaOutletHeaderYupSchema, mediaOutletOverviewYupSchema };
